import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, colors } from "../shared/constants";
import { styles, inputStyle, labelStyle } from "../shared/styles";
import { SiteDetail } from "./SiteDetail";
import { SiteFormModal } from "./SiteFormModal";

export function SitesPage() {
  const [sites, setSites] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAccountPicker, setShowAccountPicker] = useState(false);
  const [addSiteAccountId, setAddSiteAccountId] = useState(null);
  const [pickerAccountId, setPickerAccountId] = useState("");
  const [search, setSearch] = useState("");
  const [hovered, setHovered] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const loadData = () => {
    Promise.all([axios.get(`${API}/sites/`), axios.get(`${API}/accounts/`)])
      .then(([sitesRes, accountsRes]) => {
        setSites(sitesRes.data);
        setAccounts(accountsRes.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    loadData();
  }, []);
  const accountName = (id) =>
    accounts.find((a) => a.id === id)?.account_name || "—";

  const openAddSite = () => {
    setPickerAccountId(accounts.length > 0 ? String(accounts[0].id) : "");
    setShowAccountPicker(true);
  };
  const confirmAccount = () => {
    if (!pickerAccountId) return;
    setShowAccountPicker(false);
    setAddSiteAccountId(Number(pickerAccountId));
  };
  const filtered = sites.filter(
    (s) =>
      s.site_name.toLowerCase().includes(search.toLowerCase()) ||
      s.site_address.toLowerCase().includes(search.toLowerCase()) ||
      accountName(s.account).toLowerCase().includes(search.toLowerCase()),
  );
  if (selectedSite)
    return (
      <SiteDetail
        siteId={selectedSite.id}
        accountId={selectedSite.accountId}
        onBack={() => setSelectedSite(null)}
      />
    );
  return (
    <div>
      <div style={styles.topbar}>
        <div style={styles.pageTitle}>Sites</div>
      </div>
      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.searchBar}>
            <input
              style={{ ...styles.searchInput, maxWidth: "50%" }}
              placeholder="Search by site name, address or account..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button style={styles.addButton} onClick={openAddSite}>
              + Add Site
            </button>
          </div>
          <div
            style={{
              ...styles.tableHeader,
              gridTemplateColumns: "2fr 2fr 2fr 1fr",
            }}
          >
            <div>Site Name</div>
            <div>Address</div>
            <div>Account</div>
            <div>Status</div>
          </div>
          {loading ? (
            <div style={styles.loading}>Loading...</div>
          ) : filtered.length === 0 ? (
            <div style={styles.loading}>No sites found.</div>
          ) : (
            filtered.map((site) => (
              <div
                key={site.id}
                style={{
                  ...styles.tableRow(hovered === site.id),
                  gridTemplateColumns: "2fr 2fr 2fr 1fr",
                }}
                onMouseEnter={() => setHovered(site.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <div
                  style={{
                    fontWeight: "500",
                    color: colors.text,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setSelectedSite({ id: site.id, accountId: site.account })
                  }
                >
                  {site.site_name}
                </div>
                <div style={{ fontSize: "13px", color: "#666" }}>
                  {site.site_address}
                </div>
                <div style={{ fontSize: "13px", color: "#666" }}>
                  {accountName(site.account)}
                </div>
                <div>
                  <span style={styles.statusBadge(site.status)}>
                    {site.status.charAt(0).toUpperCase() + site.status.slice(1)}
                  </span>
                </div>
              </div>
            ))
          )}
          <div style={styles.count}>
            {filtered.length} Site{filtered.length !== 1 ? "s" : ""}
          </div>
        </div>
      </div>
      {/* Account picker before opening SiteFormModal */}
      {showAccountPicker && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "28px", width: "360px", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }}>
            <div style={{ fontSize: "16px", fontWeight: "700", color: colors.text, marginBottom: "20px" }}>Select Account for New Site</div>
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>Account *</label>
              <select
                style={{ ...inputStyle, appearance: "auto" }}
                value={pickerAccountId}
                onChange={(e) => setPickerAccountId(e.target.value)}
              >
                {accounts.map((a) => (
                  <option key={a.id} value={a.id}>{a.account_name}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button onClick={() => setShowAccountPicker(false)} style={{ padding: "8px 18px", borderRadius: "8px", border: `1px solid ${colors.border}`, background: "white", cursor: "pointer", fontSize: "14px" }}>Cancel</button>
              <button onClick={confirmAccount} style={{ ...styles.addButton, padding: "8px 18px" }}>Continue</button>
            </div>
          </div>
        </div>
      )}

      {/* Site creation modal */}
      {addSiteAccountId && (
        <SiteFormModal
          accountId={addSiteAccountId}
          existingSite={null}
          onClose={() => setAddSiteAccountId(null)}
          onSave={() => { setAddSiteAccountId(null); loadData(); }}
        />
      )}
    </div>
  );
}
